import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import './OrbitNavbar.css';
import { ORBIT_NAV, SCARCITY } from '../pages/Membership360/orbitContent';

const OrbitNavbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [compact, setCompact] = useState(false);
  const location = useLocation();
  const close = () => setOpen(false);

  useEffect(() => {
    close();
  }, [location.pathname, location.hash]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 920px)');
    const sync = () => {
      setCompact(mq.matches);
      if (!mq.matches) setOpen(false);
    };
    sync();
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') close();
    };
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <header className={`orbit-nav${scrolled ? ' is-scrolled' : ''}${open ? ' is-open' : ''}`}>
      <div className="orbit-nav-inner">
        <Link
          to="/"
          className="orbit-nav-brand"
          onClick={close}
          aria-label="Unschooling home"
        >
          <span className="orbit-nav-mark-wrap" aria-hidden="true">
            <img
              className="orbit-nav-mark"
              src="/brand/unschooling-mark.svg"
              alt=""
              width={36}
              height={36}
              decoding="async"
            />
          </span>
          <span className="orbit-nav-wordmark">
            <span className="orbit-nav-name">Unschooling</span>
          </span>
        </Link>

        <button
          type="button"
          className={`orbit-nav-burger${open ? ' is-open' : ''}`}
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          aria-controls="orbit-nav-menu"
          onClick={() => setOpen((v) => !v)}
        >
          <span className="orbit-nav-burger-line" />
          <span className="orbit-nav-burger-line" />
          <span className="orbit-nav-burger-line" />
        </button>

        <div
          className={`orbit-nav-backdrop${open ? ' is-open' : ''}`}
          aria-hidden="true"
          onClick={close}
        />

        <nav
          id="orbit-nav-menu"
          className={`orbit-nav-links${open ? ' is-open' : ''}`}
          aria-label="Orbit"
          aria-hidden={compact ? !open : undefined}
        >
          <p className="orbit-nav-sheet-label">Explore</p>
          {ORBIT_NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              onClick={close}
              className={({ isActive }) =>
                `orbit-nav-link${isActive ? ' is-active' : ''}`
              }
              tabIndex={compact && !open ? -1 : undefined}
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            className="orbit-nav-cta"
            to="/orbit/join#interest"
            onClick={close}
            tabIndex={compact && !open ? -1 : undefined}
          >
            {SCARCITY.nav}
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default OrbitNavbar;
